module.exports = __webpack_public_path__ + "static/media/295461.6519a539.png";